/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_UnavailableInputs */

const en_read_along_ai_unavailable = /** @type {(inputs: Read_Along_Ai_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unavailable`)
};

const es_read_along_ai_unavailable = /** @type {(inputs: Read_Along_Ai_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No disponible`)
};

/**
* | output |
* | --- |
* | "Unavailable" |
*
* @param {Read_Along_Ai_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_unavailable = /** @type {((inputs?: Read_Along_Ai_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_unavailable(inputs)
	return en_read_along_ai_unavailable(inputs)
});